<template>
    <el-dialog :visible.sync="visible" :title="!dataForm.id ? $t('add') : $t('update')" :close-on-click-modal="false"
               :close-on-press-escape="false">
        <el-form :model="dataForm" :rules="dataRule" ref="dataForm" @keyup.enter.native="dataFormSubmitHandle()"
                 :label-width="$i18n.locale === 'en-US' ? '120px' : '80px'">
            <el-form-item label="标题" prop="title">
                <el-input v-model="dataForm.title" placeholder="标题"></el-input>
            </el-form-item>
            <el-form-item label="视频类型" prop="videoType">
                <el-select v-model="dataForm.videoType"
                           placeholder="视频类型">
                    <el-option v-for="item in videoTypes"
                               :key="item.value"
                               :label="item.label"
                               :value="item.value">
                    </el-option>
                </el-select>
            </el-form-item>
            <el-form-item label="封面图" prop="coverUrl">
                <el-upload :class="{hide:hideUpload}" :action="this.actionUrl"
                           list-type="picture-card" :file-list="coverFileList"
                           :before-upload="beforeAvatarUpload"
                           :on-success="handleAvatarSuccess" :on-preview="handlePictureCardPreview"
                           :on-remove="handleRemove" :limit="1">
                    <i class="el-icon-plus"></i>
                </el-upload>
                <!--            <el-input v-model="dataForm.coverUrl" placeholder="封面图"></el-input>-->
            </el-form-item>
            <el-form-item label="视频" prop="videoUrl">
                <!--            <el-input v-model="dataForm.videoUrl" placeholder="视频"></el-input>-->
                <el-upload :action="this.actionUrl"
                           :file-list="mainFileList"
                           list-type="picture"
                           :before-upload="beforeVideoUpload"
                           :on-success="handleVideoSuccess"
                           :on-preview="handlePictureCardPreview"
                           :on-remove="handleRemove" :limit="1">
                    <i class="el-icon-plus"></i>
                </el-upload>
            </el-form-item>
            <el-form-item label="排序" prop="orderSort">
                <el-input v-model="dataForm.orderSort" placeholder="排序"></el-input>
            </el-form-item>
        </el-form>
        <template slot="footer">
            <el-button @click="visible = false">{{ $t('cancel') }}</el-button>
            <el-button type="primary" @click="dataFormSubmitHandle()">{{ $t('confirm') }}</el-button>
        </template>
    </el-dialog>
</template>

<script>
    import debounce from 'lodash/debounce'
    import Cookies from "js-cookie";

    export default {
        data() {
            return {
                visible: false,
                actionUrl: '',
                hideUpload: false,
                mainFileList: [],
                coverFileList: [],
                videoTypes: [{
                    value: 1,
                    label: '视频教程'
                }, {
                    value: 2,
                    label: '云客风采'
                }],
                dataForm: {
                    id: '',
                    title: '',
                    coverUrl: '',
                    videoUrl: '',
                    pageView: '',
                    videoType: '',
                    orderSort: '',
                    attentionNum: '',
                    creator: '',
                    createDate: '',
                    updateDate: ''
                }
            }
        },
        computed: {
            dataRule() {
                return {
                    title: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    coverUrl: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    videoUrl: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    pageView: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    videoType: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    attentionNum: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ],
                    updateDate: [
                        {required: true, message: this.$t('validate.required'), trigger: 'blur'}
                    ]
                }
            }
        },
        methods: {
            //文件上传
            beforeAvatarUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 10;

                if (!isLt2M) {
                    this.$message.error('图片大小不能超过 10MB!');
                }
                return isLt2M;
            },
            handleAvatarSuccess(res, file, fileList) {
                // this.dataForm.mainPicture = URL.createObjectURL(file.raw);
                this.dataForm.coverUrl = res.data.src
                this.hideUpload = fileList.length >= 1
            },
            //文件上传
            beforeVideoUpload(file) {
                const isLt2M = file.size / 1024 / 1024 < 100;

                if (!isLt2M) {
                    this.$message.error('视频大小不能超过 100MB!');
                }
                return isLt2M;
            },
            handleVideoSuccess(res, file, fileList) {
                // this.dataForm.mainPicture = URL.createObjectURL(file.raw);
                this.dataForm.videoUrl = res.data.src
                this.hideUpload = fileList.length >= 1
            },
            handleRemove(file, fileList) {
                this.hideUpload = fileList.length >= 1;
            },
            handlePictureCardPreview(file) {
                this.dialogImageUrl = file.url;
                this.dialogVisible = true;
            },
            init() {
                this.visible = true
                this.actionUrl = this.url = `${window.SITE_CONFIG['apiURL']}/sys/oss/upload?token=${Cookies.get('token')}`;
                console.log(this.actionUrl)
                this.mainFileList = []
                this.coverFileList = []
                this.hideUpload = false
                this.$nextTick(() => {
                    this.$refs['dataForm'].resetFields()
                    if (this.dataForm.id) {
                        this.getInfo()
                    }
                })
            },
            // 获取信息
            getInfo() {
                this.$http.get(`/ums/videocourse/${this.dataForm.id}`).then(({data: res}) => {
                    if (res.code !== 0) {
                        return this.$message.error(res.msg)
                    }
                    this.dataForm = {
                        ...this.dataForm,
                        ...res.data
                    }
                    this.mainFileList = [{
                        name: '已上传文件',
                        url: this.dataForm.videoUrl
                    }]
                    this.coverFileList = [{
                        name: '已上传文件',
                        url: this.dataForm.coverUrl
                    }]
                }).catch(() => {
                })
            },
            // 表单提交
            dataFormSubmitHandle: debounce(function () {
                this.$refs['dataForm'].validate((valid) => {
                    if (!valid) {
                        return false
                    }
                    this.$http[!this.dataForm.id ? 'post' : 'put']('/ums/videocourse/', this.dataForm).then(({data: res}) => {
                        if (res.code !== 0) {
                            return this.$message.error(res.msg)
                        }
                        this.$message({
                            message: this.$t('prompt.success'),
                            type: 'success',
                            duration: 500,
                            onClose: () => {
                                this.visible = false
                                this.$emit('refreshDataList')
                            }
                        })
                    }).catch(() => {
                    })
                })
            }, 1000, {'leading': true, 'trailing': false})
        }
    }
</script>
